import { Component, DestroyRef, ElementRef, HostBinding, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';

import { AdaptiveLayoutService } from '@frontend/sports/layout/feature';
import { PopupAction } from '@frontend/sports/modal/feature';
import { WINDOW } from '@frontend/vanilla/core';
import { filter, fromEvent, skip } from 'rxjs';

import { SportListBodyComponent } from '../../../event-list-shared/sport/overview/sport-list-body.component';
import { NavigationRouterService } from '../../../navigation/navigation-router.service';
import { PopupManager } from '../../../popup/popup-manager.service';

@Component({
    imports: [SportListBodyComponent],
    selector: 'ms-sport-list-modal',
    templateUrl: 'sport-list-modal.component.html',
})
export class SportListModalComponent implements OnInit, OnDestroy {
    @HostBinding('class') get className(): string {
        return this.adaptiveLayout.current.showDesktopAZSports ? 'az-sports-desktop' : 'sport-list-modal modal-popup sports';
    }

    private isNavigationStartEvent = false;

    hasTopGroup = false;
    isDesktopResolution: boolean;
    private readonly _window = inject(WINDOW);

    constructor(
        private adaptiveLayout: AdaptiveLayoutService,
        private popupManager: PopupManager,
        private elementRef: ElementRef,
        private navigationRouter: NavigationRouterService,
        private router: Router,
        private destroyRef: DestroyRef,
    ) {}

    ngOnInit(): void {
        this.hasTopGroup = this.adaptiveLayout.current.showDesktopAZSports ? false : this.popupManager.isPopupOpen('sports');
        this.isDesktopResolution = this.adaptiveLayout.current.showDesktopAZSports;

        fromEvent(this._window, 'click')
            .pipe(
                filter((e) => !this.elementRef.nativeElement.contains(e.target)),
                skip(1), // skipping first click since this is triggered by the menu item which opens the popup
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe((event) => {
                if (!this.isNavigationStartEvent) {
                    this.closeMenu(event);
                }
            });

        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationStart),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe(() => {
                this.isNavigationStartEvent = true;
                this.closeMenu({} as Event, true);
            });
    }

    ngOnDestroy() {
        this.navigationRouter.restoreLastActiveItem();
    }

    closeMenu(event: Event | {}, isNavigationStart: boolean = false): void {
        if (event instanceof Event) {
            event.preventDefault();
        }

        const popupActionOption = isNavigationStart ? PopupAction.CloseByNavigation : PopupAction.ManualClose;
        this.popupManager.close(popupActionOption);
    }
}
